import React from 'react';

function Donation() {
    return (
        <section className="section">
            <div className="section__inner">
                <p className="heading-3">
                    Want to help us complete this next chapter?
                </p>
                <a href="https://www.buymeacoffee.com/decades" className="button button--cherry" target="_blank" rel="noreferrer">
                    CLick here to donate
                </a>
            </div>
        
        </section>
    );
}

export default Donation;